import request from "@/utils/request";

/**
 * 获取当前用户投诉建议列表
 * @param {Object} params
 * @param {string} params.type - 类型（complaint=投诉, advice=建议）
 * @param {string} params.status - 状态（wait=待处理, completed=已处理）
 */
export function getMyComplaintAdvice(params) {
  return request({
    url: "/app/complaintAdvice/myComplaintAdvice",
    method: "get",
    params,
  });
}

/**
 * 提交投诉建议
 * @param {Object} data
 * @param {string} data.type - 类型（complaint=投诉, advice=建议）
 * @param {number|null} data.demandOrderId - 订单ID
 * @param {string} data.feedbackContent - 反馈内容
 * @param {string} data.relationPhone - 联系电话
 * @param {string} data.picture - 图片URL
 */
export function addComplaintAdvice(data) {
  return request({
    url: "/app/complaintAdvice",
    method: "post",
    data,
  });
}

/**
 * 取消投诉建议
 * @param {Object} data
 * @param {number} data.complaintAdviceId - 投诉建议ID
 * @param {string} data.resultExplain - 结果说明
 */
export function cancelComplaintAdvice(data) {
  return request({
    url: "/app/complaintAdvice/cancel",
    method: "post",
    data,
  });
}
